interface AvatarProps {
  name: string | null;
  email: string;
  pictureUrl: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const sizes = { sm: 'size-8 text-xs', md: 'size-10 text-sm', lg: 'size-14 text-lg' };

function initials(name: string | null, email: string): string {
  const source = name?.trim() || email;
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const second = parts.length > 1 ? (parts[1]?.[0] ?? '') : '';
  return (first + second).toUpperCase() || '?';
}

export function Avatar({ name, email, pictureUrl, size = 'md' }: AvatarProps) {
  const label = name ?? email;
  if (pictureUrl) {
    return (
      <img
        src={pictureUrl}
        alt={label}
        referrerPolicy="no-referrer"
        className={`${sizes[size]} shrink-0 rounded-full bg-neutral-200 object-cover dark:bg-neutral-800`}
      />
    );
  }
  return (
    <span
      role="img"
      aria-label={label}
      className={`${sizes[size]} inline-flex shrink-0 items-center justify-center rounded-full bg-accent-soft font-semibold text-accent-strong dark:bg-accent/20 dark:text-accent-light`}
    >
      {initials(name, email)}
    </span>
  );
}
